var map = {
	"./auction-closed.svg": 9225,
	"./bid-win.svg": 84224,
	"./calibrate-feed.svg": 97553,
	"./change-pass-success.svg": 2927,
	"./deposit-success.svg": 82214,
	"./get-10-yrm.svg": 7447,
	"./new-bid.svg": 90375,
	"./new-like.svg": 25201,
	"./new-subscriber.svg": 48449,
	"./new-yrm.svg": 83744,
	"./nft-minted.svg": 40044,
	"./report.svg": 66849,
	"./sell-nft-success.svg": 18107,
	"./transfer-success.svg": 79917,
	"./withdraw-confirm.svg": 94169,
	"./withdraw-success.svg": 41925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27561;